import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { environment } from 'environments/environment';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';

@Component({
    selector: 'app-store-location',
    templateUrl: './store-location.component.html',
    styleUrls: ['./store-location.component.css'],
})
export class StoreLocationComponent implements OnInit {
    tabitems: any = [];

    storeId: any;
    selectedStore: any;
    cookieStore: any;

    role: any;
    routeRole: any;

    // Map Variables
    zoom = 14;
    lat = 51.673858;
    lng = 7.815982;
    @ViewChild('placesRef') placesRef: GooglePlaceDirective; // View Child for Google places search input
    markers: Marker[] = [];

    hasLocation = false;

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _storeService: StoreService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/store/details', title: 'Details' },
            { path: '/' + this.routeRole + '/store/location', title: 'Location' },
            { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
            { path: '/' + this.routeRole + '/store/media', title: 'Media' },
            { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
            { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
            { path: '/' + this.routeRole + '/store/services', title: 'Services' },
        ];

        // Maps
    }

    ngOnInit() {
        this.getStore(this.storeId);
    }

    // Get Store by id
    public getStore(id) {
        this._storeService.getStoreById(id).subscribe(
            (data: any) => {
                // console.log(data);
                this.selectedStore = data;
                if (data.latitude === null) {
                    this.hasLocation = false;
                } else {
                    this.hasLocation = true;
                    this.lat = data.latitude;
                    this.lng = data.longitude;
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
                ) {
                    this.tabitems.push({
                        path: '/' + this.routeRole + '/store/delivery-times',
                        title: 'Delivery Times',
                    });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
                        1
                    );
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
                ) {
                    this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Kiosks'),
                        1
                    );
                }
            },
            (err) => {
                console.log('Getting store by ID error, navigate to select store');
                this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
            }
        );
    }

    // handle address selection and update lat/lng of location
    public handleAddressChange(address: Address) {
        this.lat = address.geometry.location.lat();
        this.lng = address.geometry.location.lng();
        // this.createLocationForm.patchValue({'latitude': this.newLocation.latitude, 'longitude': this.newLocation.longitude});
        // this.updateMapMarker(this.newLocation.latitude, this.newLocation.longitude);
    }

    public markerDragEnd(event) {
        this.lat = event.coords.lat;
        this.lng = event.coords.lng;
    }

    // Save the location
    public saveLocation() {
        const body = {
            latitude: this.lat,
            longitude: this.lng,
            id: this.storeId,
        };
        this._storeService.updateStoreLocation(body).subscribe((data: any) => {
            console.log(data);
            this.getStore(this.storeId);
            this.notificationService.notify(
                'success',
                'Location Updated',
                'Store location has successfully been updated.',
                'top',
                'right'
            );
        });
    }
}

interface Marker {
    lat: number;
    lng: number;
    draggable?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/indi-store/location/store-location.component.ts